module.exports = __webpack_public_path__ + "202408221624/img/icon_star_1.74a4a6f5.png";